module.exports = __webpack_public_path__ + "static/media/CelularCryptos1.db4eb2b5.png";